import Event from "common/event";
import { Dispatch } from "react";
import { FeatureFlagCollection } from "./featureFlags";
import featureFlagService from "./featureFlagService";

export class FeatureFlagsLoaded extends Event {
    constructor(public featureFlags: FeatureFlagCollection) {
        super(FeatureFlagsLoaded.EventName)
    }

    public static EventName: string = "FEATURE_FLAGS_LOADED";
}

export class FeatureFlagUpdated extends Event {
    constructor(public flag: keyof FeatureFlagCollection, public value: boolean) {
        super(FeatureFlagUpdated.EventName)
    }

    public static EventName: string = "FEATURE_FLAG_UPDATED";
}

export function loadFeatureFlags(dispatch: Dispatch<any>) {
    const flags = featureFlagService.loadFlags();
    dispatch(new FeatureFlagsLoaded(flags).toObject());
}

export function updateFlag(dispatch: Dispatch<any>, flag: keyof FeatureFlagCollection, value: boolean) {
    featureFlagService.setValue(flag, value);
    dispatch(new FeatureFlagUpdated(flag, value).toObject());
}